import React from 'react';
import './CouponSkeleton.css';

const CouponSkeleton = () => {
  const items = Array.from({ length: 3 });

  return (
    <div className="coupon-skeleton-container">
      {items.map((_, index) => (
        <div key={index} className="coupon-skeleton-item">
          <div className="coupon-skeleton-header-section">
            <div className="coupon-skeleton-main-info">
              <div className="coupon-skeleton-code-badge">
                <div className="coupon-skeleton-code-label"></div>
                <div className="coupon-skeleton-code-value"></div>
              </div>
              <div className="coupon-skeleton-title-section">
                <div className="coupon-skeleton-name"></div>
                <div className="coupon-skeleton-description"></div>
              </div>
            </div>
            <div className="coupon-skeleton-actions">
              <div className="coupon-skeleton-action-btn"></div>
              <div className="coupon-skeleton-action-btn"></div>
            </div>
          </div>

          <div className="coupon-skeleton-details-grid">
            <div className="coupon-skeleton-detail-row">
              <div className="coupon-skeleton-detail-column">
                <div className="coupon-skeleton-detail-item">
                  <div className="coupon-skeleton-detail-label"></div>
                  <div className="coupon-skeleton-detail-value"></div>
                </div>
              </div>
              <div className="coupon-skeleton-detail-column">
                <div className="coupon-skeleton-detail-item">
                  <div className="coupon-skeleton-detail-label"></div>
                  <div className="coupon-skeleton-detail-value"></div>
                </div>
              </div>
            </div>

            <div className="coupon-skeleton-detail-row">
              <div className="coupon-skeleton-detail-column">
                <div className="coupon-skeleton-detail-item">
                  <div className="coupon-skeleton-detail-label"></div>
                  <div className="coupon-skeleton-detail-value"></div>
                </div>
              </div>
              <div className="coupon-skeleton-detail-column">
                <div className="coupon-skeleton-detail-item">
                  <div className="coupon-skeleton-detail-label"></div>
                  <div className="coupon-skeleton-detail-value"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CouponSkeleton;
